
const $e73bf42412feb220$var$cardFooter = document.querySelector(".card-footer");
const $e73bf42412feb220$var$info = document.querySelector(".info");
const $e73bf42412feb220$var$icons = document.querySelector(".icons");
const $e73bf42412feb220$var$shareIcon = document.querySelectorAll(".share-icon");
const $e73bf42412feb220$var$tooltip = document.querySelector(".tooltip");
function $e73bf42412feb220$var$toggleClasses() {
    $e73bf42412feb220$var$cardFooter.classList.toggle("active");
    $e73bf42412feb220$var$info.classList.toggle("hidden");
    $e73bf42412feb220$var$icons.classList.toggle("hidden");
}
let $e73bf42412feb220$var$timeoutId;
function $e73bf42412feb220$var$handleTooltip(event) {
    if (event.type === "mouseover") {
        clearTimeout($e73bf42412feb220$var$timeoutId);
        $e73bf42412feb220$var$tooltip.style.display = "flex";
    } else if (event.type === "mouseout") $e73bf42412feb220$var$timeoutId = setTimeout(()=>{
        $e73bf42412feb220$var$tooltip.style.display = "none";
    }, 2000);
}
function $e73bf42412feb220$var$checkScreenSize() {
    $e73bf42412feb220$var$shareIcon.forEach((icon)=>{
        if (window.matchMedia("(min-width: 768px)").matches) {
            icon.removeEventListener("click", $e73bf42412feb220$var$toggleClasses);
            icon.addEventListener("mouseover", $e73bf42412feb220$var$handleTooltip);
            icon.addEventListener("mouseout", $e73bf42412feb220$var$handleTooltip);
            if ($e73bf42412feb220$var$cardFooter.classList.contains("active")) {
                $e73bf42412feb220$var$cardFooter.classList.remove("active");
                $e73bf42412feb220$var$info.classList.remove("hidden");
                $e73bf42412feb220$var$icons.classList.add("hidden");
            }
        } else {
            icon.addEventListener("click", $e73bf42412feb220$var$toggleClasses);
            $e73bf42412feb220$var$shareIcon[0].classList.remove("tooltip");
            icon.removeEventListener("mouseover", $e73bf42412feb220$var$handleTooltip);
            icon.removeEventListener("mouseout", $e73bf42412feb220$var$handleTooltip);
        }
    });
}
$e73bf42412feb220$var$checkScreenSize();
window.addEventListener("resize", $e73bf42412feb220$var$checkScreenSize);


//# sourceMappingURL=index.7b820354.js.map
